var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagicIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.969,
    height: 17.646,
    viewBox: "0 0 15.969 17.646",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_63232",
    "data-name": "Group 63232",
    transform: "translate(0 -1.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Star_1",
    "data-name": "Star 1",
    d: "M6.547,0S6.614,3.405,8,4.775C9.372,6.129,12.73,6.183,12.73,6.183S9.343,6.548,8,8c-1.31,1.42-1.455,4.728-1.455,4.728S6.324,9.419,5,8C3.575,6.487,0,6.183,0,6.183s3.547.009,5-1.408C6.4,3.4,6.547,0,6.547,0Z",
    transform: "translate(0 5.636)",
    fill: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star_1-2",
    "data-name": "Star 1",
    d: "M3.894,0s.04,2.025.865,2.84a5.084,5.084,0,0,0,2.812.837A5.523,5.523,0,0,0,4.759,4.759a5.514,5.514,0,0,0-.865,2.812,5.662,5.662,0,0,0-.923-2.812C2.126,3.858,0,3.677,0,3.677s2.109.006,2.971-.837A5.243,5.243,0,0,0,3.894,0Z",
    transform: "translate(8.397 1.85)",
    fill: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star_1-3",
    "data-name": "Star 1",
    d: "M2.892,0a3.781,3.781,0,0,0,.643,2.11,3.777,3.777,0,0,0,2.089.622,4.1,4.1,0,0,0-2.089.8,4.1,4.1,0,0,0-.643,2.089,4.206,4.206,0,0,0-.685-2.089A4.227,4.227,0,0,0,0,2.732,3.906,3.906,0,0,0,2.207,2.11,3.9,3.9,0,0,0,2.892,0Z",
    transform: "translate(9.371 13.871)",
    fill: "#fcfcfc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicIcon);
export default __webpack_public_path__ + "static/media/magicIcon.7e9773fa90e9040f814529435f5f59c1.svg";
export { ForwardRef as ReactComponent };